import { rem, size } from 'polished';
import styled, { css } from 'styled-components';

import { breakpoints } from 'helpers/styles/constants';
import { container } from 'helpers/styles/mixins';

export const MainTitles = styled.div`
  ${container()};
  padding-top: ${rem(75)};
  margin-bottom: ${rem(50)};
`;

const FontStyles = css`
  font-family: ${({ theme }) => theme.fontFamilies.sec};
  font-weight: ${({ theme }) => theme.fontWeights.secNormal};
`;

export const Title = styled.h1`
  position: relative;
  margin-top: 0;
  margin-bottom: ${rem(40)};
  font-size: ${({ theme }) => theme.fontSizes.bigSm};
  ${FontStyles};

  @media ${breakpoints.smUp} {
    ${({ theme }) => theme.fontSizes.big};
  }

  &::before {
    content: '';
    position: absolute;
    bottom: ${rem(-10)};
    left: 0;
    ${size(rem(2), rem(70))};
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

export const SubTitle = styled.h2`
  ${FontStyles};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.subTitle};

  @media ${breakpoints.smUp} {
    font-size: ${({ theme }) => theme.fontSizes.mediumLg};
  }
`;
